import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Phone, Mail, MapPin, Send, Globe } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    organisation: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/contact`, formData);

      if (response.data.status === 'success') {
        toast.success('Thank you! Your enquiry has been submitted successfully.');
        setFormData({
          name: '',
          organisation: '',
          email: '',
          phone: '',
          message: ''
        });
      }
    } catch (error) {
      toast.error('Failed to submit enquiry. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Contact Information - Centered */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Get In Touch
          </h2>
          <p className="text-slate-600 mb-12 leading-relaxed text-lg max-w-2xl mx-auto">
            Contact us to discuss how we can support your infrastructure project delivery. We work with non-government clients, government agencies and councils across NSW.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-sm min-h-[120px]">
            <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center flex-shrink-0">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <div>
              <h4 className="font-semibold text-slate-900 mb-1">Phone</h4>
              <a href="tel:+61400106677" className="text-slate-600 hover:text-blue-900 transition-colors duration-200">
                +61 400 106 677
              </a>
            </div>
          </div>

          <div className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-sm min-h-[120px]">
            <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center flex-shrink-0">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <div className="min-w-0">
              <h4 className="font-semibold text-slate-900 mb-1">Email</h4>
              <a href="mailto:admin@rheprojectconsulting.com.au" className="text-slate-600 hover:text-blue-900 transition-colors duration-200 whitespace-nowrap">
                admin@rheprojectconsulting.com.au
              </a>
            </div>
          </div>

          <div className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-sm min-h-[120px]">
            <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center flex-shrink-0">
              <MapPin className="w-6 h-6 text-white" />
            </div>
            <div>
              <h4 className="font-semibold text-slate-900 mb-1">Office Address</h4>
              <p className="text-slate-600">1 Tudor Street<br />Newcastle West, NSW 2302</p>
            </div>
          </div>

          <div className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-sm min-h-[120px]">
            <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center flex-shrink-0">
              <Globe className="w-6 h-6 text-white" />
            </div>
            <div>
              <h4 className="font-semibold text-slate-900 mb-1">Website</h4>
              <p className="text-slate-600">rheprojectconsulting.com.au</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};